<template>
  <v-row>
    <v-col>
      <v-card class="elevation-0">
        <v-card-text>
          <food-browser />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import FoodBrowser from './components/FoodBrowser'

export default {
  name: 'FoodSearchIndex',
  components: {
    'food-browser': FoodBrowser
  },
  data: () => ({
  }),
  methods: {
    
  }
};
</script>